import { render } from "./browserecord.vue?vue&type=template&id=774d4b7c&scoped=true&ts=true"
import script from "./browserecord.vue?vue&type=script&lang=ts"
export * from "./browserecord.vue?vue&type=script&lang=ts"

import "./browserecord.vue?vue&type=style&index=0&id=774d4b7c&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774d4b7c"]])

export default __exports__